var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.66898V12.3315C1.99992 12.4089 2.01783 12.4853 2.05232 12.5547C2.08681 12.624 2.13694 12.6844 2.19875 12.7311C2.26056 12.7777 2.33237 12.8094 2.40851 12.8236C2.48465 12.8377 2.56304 12.834 2.6375 12.8127L13.6375 9.60648C13.742 9.57659 13.834 9.51343 13.8994 9.42659C13.9648 9.33975 14.0001 9.23395 14 9.12523V6.87523C14.0001 6.76651 13.9648 6.66072 13.8994 6.57388C13.834 6.48704 13.742 6.42388 13.6375 6.39398L2.6375 3.18773C2.56304 3.16644 2.48465 3.16273 2.40851 3.1769C2.33237 3.19107 2.26056 3.22274 2.19875 3.2694C2.13694 3.31606 2.08681 3.37644 2.05232 3.44579C2.01783 3.51513 1.99992 3.59154 2 3.66898Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.2311V12.4998C11.5 12.6324 11.4473 12.7596 11.3536 12.8534C11.2598 12.9471 11.1326 12.9998 11 12.9998H9C8.86739 12.9998 8.74021 12.9471 8.64645 12.8534C8.55268 12.7596 8.5 12.6324 8.5 12.4998V4.89355",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.7c935cb0.svg";
export { ForwardRef as ReactComponent };